import { motion } from "framer-motion";
import { Star } from "lucide-react";

interface ThousandMonthsReminderProps {
  nightNumber: number;
}

export const ThousandMonthsReminder = ({ nightNumber }: ThousandMonthsReminderProps) => {
  const isOddNight = nightNumber % 2 !== 0;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.05 }}
      className="bg-gradient-to-br from-gold/10 to-transparent rounded-sm p-6 border border-gold/20 text-center space-y-4"
    >
      <div className="flex justify-center gap-1.5">
        {[...Array(3)].map((_, i) => (
          <Star key={i} className="w-2.5 h-2.5 text-gold" fill="currentColor" />
        ))}
      </div>

      <p className="font-arabic text-lg text-cream/90 leading-relaxed" dir="rtl">
        لَيْلَةُ الْقَدْرِ خَيْرٌ مِّنْ أَلْفِ شَهْرٍ
      </p>

      <p className="text-cream/70 text-sm max-w-md mx-auto leading-relaxed">
        {isOddNight
          ? "This is an odd night — it may be Laylatul Qadr. Worship tonight carries the reward of more than a thousand months."
          : "This night may be Laylatul Qadr. Every act of worship tonight is multiplied beyond measure."
        }
      </p>

      <p className="text-gold/40 text-xs uppercase tracking-wider">
        Night {nightNumber} of Ramadan
      </p>
    </motion.div>
  );
};
